import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  class: "w-8 sm:w-10",
  viewBox: "0 0 79 69"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#05C77E",
      "fill-rule": "evenodd",
      d: "M0 46.081a2 2 0 0 1 2-2h74.724a2 2 0 1 1 0 4H2a2 2 0 0 1-2-2m15.35 10c0-1.103.893-1.997 1.996-1.997h44.031a1.997 1.997 0 0 1 0 3.994H17.346a1.997 1.997 0 0 1-1.997-1.997zm15.344 10a2 2 0 0 1 2-2h13.335a2 2 0 0 1 0 4H32.694a2 2 0 0 1-2-2",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#05C77E",
      "fill-rule": "evenodd",
      d: "M51.736 14.254a2 2 0 0 1 1.67 1.021L70.12 45.103a2 2 0 1 1-3.49 1.956L51.517 20.087l-7.785 11.725A2 2 0 0 1 40.4 29.6l9.595-14.453a2 2 0 0 1 1.741-.893",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#05C77E",
      d: "M54.661.125c7.183 0 13.006 5.823 13.006 13.006 0 5.638-3.587 10.438-8.604 12.242l-1.869-3.337a9.26 9.26 0 0 0 6.723-8.905 9.256 9.256 0 1 0-18.512 0c0 2.207.772 4.233 2.062 5.824l-2.144 3.23a12.96 12.96 0 0 1-3.668-9.054c0-7.183 5.823-13.006 13.006-13.006"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#05C77E",
      "fill-rule": "evenodd",
      d: "M29.522 9.868a2 2 0 0 1 1.74.906l22.33 34.214a2 2 0 0 1-3.349 2.186L29.715 15.721l-17.624 31.34a2 2 0 0 1-3.486-1.96l19.24-34.214a2 2 0 0 1 1.677-1.019",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }